var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErgoLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6979 11.7378L18.3358 6.03509C18.2663 5.86717 18.1328 5.73375 17.9649 5.66419L12.2622 3.30213C12.0943 3.23262 11.9057 3.23262 11.7377 3.30213L6.03522 5.66419C5.86729 5.73375 5.73387 5.86717 5.6643 6.03509L3.30225 11.7378C3.26776 11.8209 3.25 11.91 3.25 12C3.25 12.09 3.26776 12.1792 3.30225 12.2623L5.6643 17.9648C5.73387 18.1327 5.86729 18.2661 6.03522 18.3357L11.7377 20.6978C11.8209 20.7322 11.91 20.75 12 20.75C12.09 20.75 12.1791 20.7322 12.2622 20.6978L17.9649 18.3357C18.1328 18.2661 18.2663 18.1327 18.3358 17.9648L20.6979 12.2623C20.7674 12.0944 20.7674 11.9057 20.6979 11.7378ZM14.832 9.75245H11.5165L13.5717 11.9047L11.4444 14.2474H14.8311V15.8212H9.16874V14.3907L11.3969 11.9241L9.17944 9.61326V8.17888H14.8312L14.832 9.75245Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErgoLogoIcon);
export default __webpack_public_path__ + "static/media/ergo-logo-icon.edac8dd0.svg";
export { ForwardRef as ReactComponent };